import { injectIntl } from "react-intl";

const DeleteSchedule = (props) => {
  const formattedDate = new Date(
    props.calendars?.length > 0
      ? props.calendars[0].date
      : props.calendars?.date
  ).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });

  return (
    <div className="NewStrategyModalOverlay">
      <div className="DeleteStrategyModal">
        <div className={"w-full flex justify-between"}>
          <div className={"DeleteStrategy"}>
            <img
              alt={"Logo"}
              src={"/media/icons/deleteIcon.svg"}
              className={"w-[18px] h-[18px]"}
            />
            Are you sure you want to delete {props.calendar?.list_id?.type} List
            scheduled for {formattedDate}?
          </div>
          <button className={"CloseIconButton"} onClick={props.close}>
            <img
              alt={"Logo"}
              src={"/media/icons/closeIcon.svg"}
              className={"w-5 h-5"}
            />
          </button>
        </div>
        <div className={"flex flex-col gap-4 w-full"}>
          <div className={"HorizontalDivider"}></div>
          <div className={"StrategyDeleteWarning"}>
            Are you sure you want to delete {props.calendar?.list_id?.type} List
            scheduled for {formattedDate}? This action cannot be undone.
          </div>
          <div className={"HorizontalDivider"}></div>
        </div>
        <div className={"modal-actions"}>
          <button className={"CloseButton"} onClick={props.close}>
            Cancel
          </button>
          <button
            className={"DeleteButton"}
            onClick={() =>
              props.deleteSchedule(
                props.calendars?.length > 0 ? props.calendars[0].date : null
              )
            }
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(DeleteSchedule);
